<template>
  <div class="landing-why landing-section">
    <div class="container">
        <div class="row">
            <div class="col">
                <h2 data-aos="fade-right">{{ $t('landing.why.title', 'landing') }}</h2>
            </div>
        </div>
        <div class="row rows trigger-sections">
            <div class="col-sm">
                <img src="@/assets/img/landing/globe.png" data-aos="fade-up">
                <h3 data-aos="fade" data-aos-delay="500" data-aos-anchor=".trigger-sections">{{ $t('landing.why.subtitle_1', 'landing') }}</h3>
                <p data-aos="fade" data-aos-delay="500" data-aos-anchor=".trigger-sections">{{ $t('landing.why.descr_1', 'landing') }}</p>
            </div>
            <div class="col-sm">
                <img src="@/assets/img/landing/laptop.png" data-aos="fade-up">
                <h3 data-aos="fade" data-aos-delay="500" data-aos-anchor=".trigger-sections">{{ $t('landing.why.subtitle_2', 'landing') }}</h3>
                <p data-aos="fade" data-aos-delay="500" data-aos-anchor=".trigger-sections">{{ $t('landing.why.descr_2', 'landing') }}</p>
            </div>
            <div class="col-sm">
                <img src="@/assets/img/landing/handshake.png" data-aos="fade-up">
                <h3 data-aos="fade" data-aos-delay="500" data-aos-anchor=".trigger-sections">{{ $t('landing.why.subtitle_3', 'landing') }}</h3>
                <p data-aos="fade" data-aos-delay="500" data-aos-anchor=".trigger-sections">{{ $t('landing.why.descr_3', 'landing') }}</p>
            </div>
        </div>
    </div>
  </div>
</template>

<script>

export default {
    name      : 'Why',
    components: {
    },
    data () {
        return {
        }
    },
    watch: {
    },
    mounted () {
    },
    computed: {
    },
    methods: {
        a() {

        }
    },
}
</script>

<style scoped lang="scss">
    @import '@/assets/scss/_variables.scss';

    .landing-why { 
        background-color: $teal;
        margin-top: -98px;
        overflow: auto;

        h2 {
            margin-top: 86px;
            text-align: center;

            font-family: 'Robusta TL Pro';
            font-style: normal;
            font-weight: 900;
            font-size: 40px;
            line-height: 78px;

            /* identical to box height, or 194% */
            text-align: center;
            text-transform: uppercase;

            color: $blue;

            margin-bottom: 70px;
        }

        .rows {
            text-align: center;
        }

        img {
            height: 120px;
            margin-bottom: 50px;
        }

        h3 {
            font-family: 'Rubik';
            font-style: normal;
            font-weight: 400;
            // font-size: 30px;
            font-size: 26px;
            line-height: 30px;

            /* identical to box height, or 100% */
            text-align: center;

            /* dark blue */
            color: $blue;

            margin-bottom: 30px;
        }

        p {
            font-family: 'Rubik';
            font-style: normal;
            font-weight: 400;
            font-size: 18px;
            line-height: 25px;

            /* or 139% */
            text-align: center;

            /* black */
            color: #101010;
        }
    }

    @media only screen and (max-width: $break-sm){
        .landing-why { 

            h2 {
                font-size: 30px;
                line-height: 30px;
                margin-bottom: 0;
            }

            img {
                margin-top: 70px;
            }

            h3 {
                font-size: 20px;
                line-height: 25px;
                margin-bottom: 20px;
            }

            p {
                font-size: 16px;
                line-height: 20px;
            }
        }
    }
</style>